import TankModal, { TankFormValues } from '../../components/location-management/TankModal';
import { StorageSite, StorageTank } from '../../types/interfaces';
import { createStorageTank, updateStorageTank } from '../../api/storageItemsApi';

type RsgTankModalProps = {
  mode: 'add' | 'edit';
  close: () => void;
  site: StorageSite;
  tank?: StorageTank;
  setSelectedId?: (id: number) => void;
};

const RsgTankModal = ({ mode, close, site, tank, setSelectedId }: RsgTankModalProps): JSX.Element => {
  const tankValues = tank
    ? { name: tank.name, active: tank.active, isTravelingTank: tank.isTravelingTank }
    : undefined;

  const createTank = async ({ name, active, isTravelingTank }: TankFormValues) => {
    const { data: id } = await createStorageTank({
      name,
      active,
      isTravelingTank,
      storageSiteId: site.storageSiteId,
    });
    return id;
  };

  const updateTank = async ({ name, active, isTravelingTank }: TankFormValues) => {
    if (!tank) {
      return;
    }
    await updateStorageTank(tank.storageTankId, { name, active, isTravelingTank });
  };

  return (
    <TankModal
      mode={mode}
      close={close}
      siteName={site.name}
      tank={tankValues}
      setSelectedId={setSelectedId}
      createTank={createTank}
      updateTank={updateTank}
    />
  );
};

export default RsgTankModal;
